<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;"></div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div>
                    <el-row style="float: left;margin:10px 0">
                        <el-input  placeholder="请输入药品名称" v-model="waresDrugName" clearable style="width:200px"></el-input>
                        <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </el-row>
                    <div style="clear: both;"></div>
                </div>
                 <template>
                    <el-table :data="tableData" height="500" border>

                        <el-table-column prop="waresDrugName" label="药品名称"></el-table-column>

                        <!-- <el-table-column prop="count" label="供应商"></el-table-column> -->

                        <!-- <el-table-column prop="waresTypeDrugName" label="药品类型"></el-table-column> -->

                        <el-table-column prop="count" label="数量"></el-table-column>

                        <!-- <el-table-column
                                prop="Status"
                                :formatter="statusTitle"
                                label="状态">
                        </el-table-column> -->
                    </el-table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getTokenBykey} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                add_waresDrugCode:'',
                waresDrugName:'',
                stockinDrugCode:'',
                pageSize:20,
                currentPage:1,
                showModalAdd:false,
                tableData:[],
                waresDrugList:[],
                totalItems: 0,
                th:0,
                name:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                },

                rules:{
                    name:[
                        { required: true, message: '药品名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type: 'number', message: '库存必须为数字值'}
                    ],
                }


            }
        },

        methods: {
            init(row){
                this.waresDrugName=''
                this.stockinDrugCode=row.stockinDrugCode
                this.getList();
            },
            closeSelf() {
                this.$emit("closeInfo");
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            
            isAdd(code,list){
                for(var i in list){
                    if(list[i].waresDrugCode==code){
                        return false;
                    }
                }
                return true
            },
            changeWaresDrug(selVal){
                this.add_waresDrugCode=selVal;
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'StockinWaresDrug/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        stockinDrugCode:this.stockinDrugCode,
                        waresDrugName:this.waresDrugName
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        var data= response.data.data;
                        this.tableData=data
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getData(data){
                var waresDrugInfoAdd=getTokenBykey(getStaffCode()+'waresDrugInfoAdd');
                for(var i in data){
                    if(waresDrugInfoAdd){
                        if(!this.isAdd(data[i].waresDrugCode,JSON.parse(waresDrugInfoAdd))){
                            data[i].add=1
                        }else{
                            data[i].add=0
                        }
                    }else{
                        data[i].add=0
                    }
                }
                console.log(data)
                return data
            }
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:1000px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px;
        z-index: 99;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>